import { getRegistrationHeroState } from './registrationHeroState'

/**
 * Returns the one academic Hero that is useful right now.  The returned shape is
 * intentionally content-oriented so future exam/grade sources can join this
 * selector without changing HomeHeroCarousel or either home view.
 */
export function getActiveAcademicHero({ now = new Date(), grade } = {}) {
  const registrationState = getRegistrationHeroState({ now, grade })
  if (registrationState.phaseId === 'completed') return null

  return { kind: 'registration', registrationState }
}
